import React from "react";
import { usePageTitle } from "../../Context/PageTitleContext";

const PortalTitle = ({ fallback = "" }) => {
  const { pageTitle } = usePageTitle();
  const displayTitle = pageTitle || fallback;
  return displayTitle ? <div className="portaltitle">{displayTitle}</div> : null;
};

export default PortalTitle;

